import _ from 'lodash';
import { container } from '@intigral/domain/lib/DataDomain';
import { DI } from '@intigral/constant/config/DIContainer';
import user from '../../helpers/user';
import { IBookmarkService } from '@intigral/domain/lib/application/services/BookmarkService';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { invalidateTaContinueWatchingFeeds } from '../data/taFeedQueryKeys';

export const useDeleteBookmarkMutation = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async ({ bookmark }: { bookmark: any }) => {
            try {
                const assetId = bookmark.category === 'VOD' ? bookmark.mediaId : bookmark.listingId;
                const paId = bookmark.category === 'VOD' ? bookmark.Id : bookmark.paId;
                const bookmarkService = await container.resolve<IBookmarkService>(DI.SERVICES.IBookmarkService);
                await bookmarkService.deleteBookmark(
                    user.getAPIKey(),
                    user.getProfile()?.profileGuid,
                    user.getUserToken(),
                    user.getIdentityToken(),
                    assetId,
                    paId
                );
                return {
                    ItemToDelete: bookmark,
                };
            } catch (error) {
                throw error.message;
            }
        },
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ['profiles', 'bookmarks'],
            });
            invalidateTaContinueWatchingFeeds(queryClient);
        },
    });
};
